<template>
    <v-col cols="12" class="pa-3">
        <v-row>
            <v-col cols="12" md="8" class="order-md-0 order-1">
                <v-container>
                    <v-card
                        class="mx-auto transparent"
                        style="box-shadow: none"
                    >
                        <v-tabs
                            centered
                            color="IMThemeOrange"
                            class="rounded-xl mx-auto IMThemeGray"
                            style="overflow: hidden; max-width: 360px"
                        >
                            <router-link
                                v-for="(tab, i) in tabList"
                                :key="i"
                                :to="tab.link"
                            >
                                <v-tab class="p-3" :class="{'active-tab' : $router.history.current.name == tab.routName}">
                                    {{ tab.name }}
                                </v-tab>
                            </router-link>
                        </v-tabs>
                        <router-view></router-view>
                    </v-card>
                </v-container>
            </v-col>
            <v-col cols="12" md="4" class="order-md-1 order-0 text-right">
                <img src="/media/svg/victors/setting-filter.svg" alt="victor" />
                <router-view name="actions" class="text-right"></router-view>
            </v-col>
        </v-row>
    </v-col>
</template>
<style lang="scss">
.v-tabs-slider-wrapper {
    display: none !important;
}
.active-tab {
    background: #FF5F01!important;
    color: #fff !important;
}
.v-tab--active {
    background: none;
}
.v-slide-group__content a {
    flex-grow: 1;
}

td {
    text-align: center;
}
</style>
<script>
import { mapActions, mapGetters } from "vuex";
export default {
    data: () => ({
        tabs: null,
        tabList: [
            { name: "المحافظات", link: "../city/-1", routName: 'city' },
            { name: "المناطق", link: "../area/-1", routName: "area" },
            { name: "جدول الدوام", link: "../schedule/-1", routName: "schedule" }
        ],
    }),
    created() {
        this.setBreadcrumbs([
            {
                text: "الإعدادت",
                disabled: false
            },
            {
                text: "الإعدادات العامة",
                disabled: false
            }
        ]);
    },
    methods: {
        ...mapActions(["setBreadcrumbs"])
    }
};
</script>
